<template>
  <div class="page page-payment container is-fluid">
    <div class="container container-inner">
      <div class="columns is-gapless is-multiline">

        <!-- <div class="column content is-hidden-tablet" style="margin-top:0;padding-top:0;" data-aos="fade-up" data-aos-once="true">
          <img src="../assets/image-07.jpg" class="img-responsive" />
        </div> -->

        <div class="column content content-main is-right" data-aos="fade-up" data-aos-once="true" data-aos-delay="300" v-if="dataPayment">
          <div class="title">
            {{ dataPayment.title }}
          </div>
          <markdown v-if="dataPayment.content" :source="dataPayment.content" style="margin-top:45px;" />
          <!-- <div class="text">
            CMS accepts credit/debit cards for your convenience. The rate is 2.95% or minimum of $2. The convenience fee is the charge of the 3rd party vendor. The method of using a third party vendor and charging a convenience fee is widely used throughout the U.S. We  receive NONE of the convenience fee. Payments can also be made in person at the office in the form of a money order or mailed to our office address.
          </div>
          <div class="subtitle" style="margin-top:30px;">
            CREDIT/DEBIT CARD PAYMENTS MAY BE MADE:
          </div>
          <div class="text">
            At our office or online by clicking on the button below.
          </div>
          <a href="#" class="button" style="margin-top:15px;margin-bottom:8px;min-width:100px;padding-left:52px;padding-right:52px;">Pay Online</a>
          <br />
          <img src="../assets/payment.svg" width="180" />
          <div class="text" style="margin-top:15px;">
            The processing fee, authorized by you, allows us to provide this service. If you have questions, please contact your probation officer.
          </div>
          <div class="text" style="margin-top:15px;">
            Thank you for fulfilling your payment obligation.
          </div> -->
        </div>

        <!-- <div class="column content" style="margin-top:0;padding-top:0;" data-aos="fade-up" data-aos-once="true">
          <img src="../assets/image-07.jpg" class="img-responsive is-hidden-mobile" />
          <div class="box color-gray-lighter-bg" v-if="false">
            <div class="text">
              For those in need of a Spanish speaking representative we have an associate available for you. Para aquellos que necesiten un representante que hable español tenemos un representante  disponible para asistirlo.
            </div>
          </div>
        </div>

        <div class="column content is-hidden-tablet" style="margin-bottom:0;" v-if="false">
          <div class="box color-gray-lighter-bg">
            <div class="subtitle" style="margin-bottom:0.8em;">
              Collection and Probation Services
            </div>
            <div class="text">
              We provide range of services. Click <a href="/services">here</a> for our list of services.
            </div>
          </div>
        </div> -->

      </div>
    </div>
  </div>
</template>

<script>
import Markdown from 'vue-markdown'
import EventBus from '@/controllers/EventBus'

import Site from '@/apis/Site'

export default {
  name: 'page-payment',
  components: {
    Markdown
  },
  data () {
    return {
      isDesktop: true,
      dataPayment: undefined
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    this.getPayment()
  },
  methods: {
    async getPayment () {
      try {
        let data
        this.dataPayment = undefined

        let replace = ''
        data = await Site.hotlinkNameLike('reference-payment')
        if (data && data[0]) {
          data = data[0]
          if (data.content && data.link) {
            replace = `<a href="${data.link}" target="_blank" class="button" style="margin-top:15px;margin-bottom:8px;min-width:100px;padding-left:52px;padding-right:52px;">${data.content}</a>`
          }
        }

        // dataPayment
        data = await Site.aboutNamed('payment')
        if (data && data[0]) {
          data = data[0]
          if (data.content) {
            data.content = data.content.replace('{%payment%}', replace)
          }
          this.dataPayment = data
        }
      } catch (error) {
        console.log('payment error', error)
      }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";
@import "../styles/page.scss";

.page-payment {
  .content {
    img[src*="#payment"] {
      width: 180px;
      height: auto;
    }
  }
}

</style>



// WEBPACK FOOTER //
// payment.vue?d4e0f344